import * as React from "react";
const SvgComputer = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.31 1.871v4.504h1.508V3.379h8.803V20.62h-5.338v1.508h6.846V1.87h-5.91Zm7.499 2.631v1.402h1.505V4.502h-.752ZM1.87 7.969v10.877h7.037v1.776H5.904V22.128h7.508l-.004-.752-.002-.752-1.5-.002-1.5-.002v-1.775h7.037V7.969H9.658ZM3.38 9.465h12.557v7.883H3.378v-3.942Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgComputer;
